import { render, staticRenderFns } from "./feedBackManage.vue?vue&type=template&id=ba4d95c8&scoped=true"
import script from "./feedBackManage.vue?vue&type=script&lang=js"
export * from "./feedBackManage.vue?vue&type=script&lang=js"
import style0 from "./feedBackManage.vue?vue&type=style&index=0&id=ba4d95c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d95c8",
  null
  
)

export default component.exports